import ApplicationsIcon from './component'

export default ApplicationsIcon